const apiUrl = process.env.REACT_APP_API_URL || 'http://api.cp.devel:8000/v2/edit';
// API origin (strip the /v2/edit suffix) — used to locate backend-served assets.
const apiOrigin = apiUrl.replace(/\/v\d+.*$/, '');

const config = {
    maintenance: false,
    // Deploy environment: 'dev' | 'staging' | 'production' (from the per-env .env file's
    // REACT_APP_SENTRY_ENVIRONMENT). Use for env-gated UI, e.g. showing sample data
    // outside production. Defaults to 'dev' when unset (local).
    env: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'dev',
    isProduction: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production',
    apiUrl,
    //v1ApiUrl: "http://api.cp.devel:8000/v1",
    v1ApiUrl: process.env.REACT_APP_API_V1_URL || 'https://api.test2.curatedplanet.com/v1',
    domainOverride: process.env.REACT_APP_DOMAIN_OVERRIDE || null, // 'curatedplanet.test2.curatedplanet.com'
    adminBaseUrl: process.env.REACT_APP_ADMIN_BASE_URL || 'https://admin.staging.curatedplanet.com',
    // The domain every company's dashboard is served under, `<code>.<dashboardDomain>` (host, plus the port
    // locally), pinned per build in .env.pro / .env.staging / .env.dev. Unset: no feature that builds another
    // company's dashboard address (the MCP handoff's franchise path) is offered.
    dashboardDomain: process.env.REACT_APP_DASHBOARD_DOMAIN || null,
    // Base URL serving the embeddable web chat widget (embed.js / widget.html).
    // Defaults to the backend's /webchat/ route (always reachable); override with
    // a CDN host (e.g. https://chat-widgets.curatedplanet.com) in production.
    widgetEmbedBaseUrl: process.env.REACT_APP_WIDGET_EMBED_BASE_URL || `${apiOrigin}/webchat`,
    enableAccessGroups: ['curatedplanet'],
    cloudWatchLogSources: process.env.REACT_APP_CLOUD_WATCH_LOG_SOURCES ? process.env.REACT_APP_CLOUD_WATCH_LOG_SOURCES.split(',') : ['/ecs/staging-web', '/ecs/staging-queue-vcache', '/ecs/staging-queue-slow', '/ecs/staging-queue-nf', '/ecs/staging-queue-import', '/ecs/staging-queue-fast', '/ecs/staging-queue-cron', '/ecs/staging-queue-chat'],
    AWSRegion: process.env.REACT_APP_AWS_REGION || 'us-east-2',
    auth0: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN || 'curatedplanet.us.auth0.com',
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '5aMyLeKymll30Igc0ZHEufpPde8lhFvS',
    },
    features: {
        useTripDefaultSettings2: true,
        tabbedGeneralSettings: true,
    }
};

export default config;
